import { render, staticRenderFns } from "./orderTables.vue?vue&type=template&id=7a265315&scoped=true&"
import script from "./orderTables.vue?vue&type=script&lang=js&"
export * from "./orderTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a265315",
  null
  
)

export default component.exports